<template lang="html">
  <span class="p-1">
    <b-tooltip label="Manage images" type="is-warning" position="is-left">
      <b-button @click="isComponentModalActive = true" class="is-warning is-inverted">
        <b-icon icon="image" size="is-big"></b-icon>
      </b-button>
    </b-tooltip>

    <b-modal
      :active.sync="isComponentModalActive"
      has-modal-card
      full-screen
      trap-focus
      aria-role="dialog"
      aria-modal
    >
      <div class="modal-card">
        <!-- Header -->
        <header class="modal-card-head">
          <p class="modal-card-title">Edit Images</p>
          <button type="button" class="delete" @click="isComponentModalActive = false" />
        </header>

        <!-- Collections Selection -->
        <section class="modal-card-body">
          <div class="columns is-vcentered">
            <div class="column">
              <p class="title is-size-4">Images</p>
            </div>
            <div class="column is-narrow">
              <b-button
                type="is-primary"
                icon-left="image-plus"
                @click="isUploadModalActive = true"
              >
                Add images
              </b-button>
            </div>
          </div>
          <div v-if="!images.length">
            <p class="is-italic has-text-gray is-size-6">
              There is no image yet, add the first one by clicking the button on the top
              right corner.
            </p>
          </div>
          <div v-else class="box">
            <draggable
              v-model="images"
              @change="changed"
              tag="div"
              class="columns is-multiline"
            >
              <div class="column is-one-fifth" v-for="image in images" :key="image.id">
                <div class="card">
                  <div class="card-image">
                    <figure class="image is-4by3">
                      <img :src="image.attributes.content.url" alt="Placeholder image" />
                    </figure>
                  </div>

                  <div class="card-content is-paddingless p-3">
                    <div class="columns is-vcentered is-multiline">
                      <div class="column is-2 has-text-right">
                        <b-icon class="is-clickable" icon="menu" type="is-gray" />
                      </div>
                      <div class="column is-8 is-paddingless pl-1">
                        <span
                          class="is-italic ellipsis2"
                          v-if="image.attributes.caption"
                          >{{ image.attributes.caption }}</span
                        ><span v-else class="is-italic has-text-gray ellipsis2"
                          >There is no caption yet.
                        </span>
                      </div>
                      <div class="column is-2 has-text-right">
                        <a @click="changeCaption(image.attributes.caption, image.id)"
                          ><b-icon icon="pencil" size="is-small" type="is-success" /></a
                        ><br />
                        <a @click="deleteImage(image.id)"
                          ><b-icon icon="delete" size="is-small" type="is-danger"
                        /></a>
                      </div>
                      <div
                        class="column has-text-gray is-full has-text-right is-paddingless px-3 pb-3"
                      >
                        <div class="field">
                          <b-checkbox
                            v-model="image.attributes.mature_content"
                            @input="changeMature($event, image.id)"
                            type="is-warning"
                            size="is-small"
                            >+18 Content</b-checkbox
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </draggable>
          </div>
        </section>

        <!-- Footer -->
        <footer class="modal-card-foot">
          <button
            class="button"
            type="button is-danger"
            @click="isComponentModalActive = false"
          >
            Close
          </button>
        </footer>
      </div>
    </b-modal>

    <!-- Modals -->
    <b-modal
      :active.sync="isUploadModalActive"
      has-modal-card
      trap-focus
      aria-role="dialog"
      aria-modal
    >
      <gallery-uploader
        :imageable-id="imageableId"
        :imageable-type="imageableType"
        @imagesUpdated="imagesUpdated"
      ></gallery-uploader>
    </b-modal>
  </span>
</template>

<script>
import { mapGetters } from 'vuex'
import draggable from 'vuedraggable'
import GalleryUploader from '@/components/concerns/Images/GalleryUploader'

export default {
  props: ['imageableType', 'imageableId'],
  components: {
    GalleryUploader,
    draggable
  },
  data () {
    return {
      offset: 0,
      images: [],
      isComponentModalActive: false,
      isUploadModalActive: false
    }
  },
  methods: {
    deleteImage (imageId) {
      this.$buefy.dialog.confirm({
        title: 'Deleting image',
        message:
          'Are you sure you want to <b>delete</b> this image? This action cannot be undone.',
        confirmText: 'Delete image',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () => {
          this.$store
            .dispatch('images/destroy', {
              imageableType: this.imageableType,
              imageableId: this.imageableId,
              imageId: imageId
            })
            .then((resp) => {
              this.imagesUpdated(resp.data.data)
            })
            .catch((error) => console.log(error.response))
        }
      })
    },
    changeCaption (caption, imageId) {
      this.$buefy.dialog.prompt({
        message: `<span class="is-size-5">Enter the new caption below.</span><br> <i class="has-text-gray" >Don't forget to mention the photographer!</i>`,
        inputAttrs: {
          placeholder: 'e.g. ABC Photography',
          maxlength: 100,
          value: caption
        },
        trapFocus: true,
        onConfirm: (value) => {
          this.$store
            .dispatch('images/update', {
              imageableType: this.imageableType,
              imageableId: this.imageableId,
              imageId: imageId,
              payload: { caption: value }
            })
            .then((resp) => {
              this.imagesUpdated(resp.data.data)
            })
            .catch((error) => console.log(error.response))
        }
      })
    },
    changeMature (value, imageId) {
      this.$store
        .dispatch('images/update', {
          imageableType: this.imageableType,
          imageableId: this.imageableId,
          imageId: imageId,
          payload: { mature_content: value }
        })
        .then((resp) => {
          this.imagesUpdated(resp.data.data)
        })
        .catch((error) => console.log(error.response))
    },
    imagesUpdated (values) {
      this.$emit('imagesUpdated', values)
      this.images = values
    },
    changed (e) {
      this.$store
        .dispatch('images/update', {
          imageableType: this.imageableType,
          imageableId: this.imageableId,
          imageId: e.moved.element.id,
          payload: { imageable_order_position: e.moved.newIndex }
        })
        .then((resp) => {
          this.imagesUpdated(resp.data.data)
        })
        .catch((error) => {
          // TODO: Handle error
          console.log(error.response.data)
        })
    }
  },
  computed: {
    ...mapGetters({
      isOwner: 'isOwner',
      isLoggedIn: 'isLoggedIn',
      currentUser: 'currentUser'
    })
  },
  created () {
    this.$store
      .dispatch('images/index', {
        imageableType: this.imageableType,
        imageableId: this.imageableId
      })
      .then((resp) => {
        this.images = resp.data.data
      })
      .catch((error) => {
        console.log('error')
        console.log(error.response)
      })
  }
}
</script>

<style lang="css" scoped></style>
